export default "__VITE_ASSET__2SEXr8ob__"